// Models
PJQ.models.budget.BaseLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    getTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('amount') + this.get('markupAmount');
        return Math.round(taxable * (taxRate / 10000));
    },
    getUnRoundedTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('amount') + this.get('markupAmount');
        return taxable * (taxRate / 10000);
    },
    resetMarkup: function () {
        this.set({
            markupAmount: 0,
            verticalMarkupAmount: 0,
            horizontalMarkupAmount: 0,
            markupValues: null
        });
    },
    getMarkupAmount: function (financialMarkups, options = {}) {
        let values = this.get('markupValues');
        if (financialMarkups != null) {
            values = {};

            let markupVals = financialMarkups.getMarkups([this]),
                hAmount = 0,
                vAmount = 0;
            _.each(markupVals, (mVal) => {
                values[mVal.cid] = {
                    amount: mVal.amount,
                    isVertical: mVal.isVertical
                };
                if(mVal.isApplied || this.markup || this.get('appliedMarkupId') > 0) {
                    vAmount += 0;
                    hAmount += 0;
                } else if (mVal.isVertical) {
                    vAmount += mVal.amount
                } else {
                    hAmount += mVal.amount;
                }
            });

            this.set({
                markupAmount: vAmount + hAmount,
                verticalMarkupAmount: vAmount,
                horizontalMarkupAmount: hAmount,
                markupValues: values
            });
        } else if (this.get('markupAmount') == null) {
            this.set({
                markupAmount: 0,
                verticalMarkupAmount: 0,
                horizontalMarkupAmount: 0
            });
        }

        if (options.cid != null) {
            let val = values[options.cid];
            if (val == null) {
                return 0;
            }
            return val.amount;
        }

        let result = null;
        if (options.vertical) {
            result = this.get('verticalMarkupAmount');
        } else if (options.horizontal) {
            result = this.get('horizontalMarkupAmount');
        }
        return result ?? this.get('markupAmount');
    },
    getAmountRemaining: function (financialMarkups, options = {}) {
        return this.getGrandTotal(financialMarkups, options) - this.get('progressAmount') - this.get('progressTaxAmount')
            - this.get('materialsStored') + this.getRetainage() - this.getRetainageReleased();
    },
    getSubTotal: function (financialMarkups, options = {}) {
        if (options == null) {
            options = {};
        }

        let result;
        if ((this.markup || this.get('appliedMarkupId') > 0) && !options.totalMarkups) {
            result = 0;
            if (_.size(options.lineItems?.models) > 0) {
                let markup = this.markup ? this.markup : financialMarkups.findWhere({id: this.get('appliedMarkupId')}),
                    markupCostCodes = markup?.get('costCodeIds') ?? [],
                    markupCostTypes = markup?.get('costTypeIds') ?? [];
                let filteredLineItems = _.filter(options.lineItems.models, (li) => {
                    return li.markup == null && financialMarkups.findWhere({lineItemId: li.id}) == null &&
                        (_.size(markupCostCodes) === 0 || markupCostCodes.includes(li.get('costCodeId'))) &&
                        (_.size(markupCostTypes) === 0 || markupCostTypes.includes(li.get('costTypeId')));
                });

                let totalAmount = 0,
                    totalRevenue = 0;
                _.each(filteredLineItems, (li) => {
                    let isAppliedLI = li.markup != null || li.get('appliedMarkupId') != null;
                    if (isAppliedLI) {
                        return;
                    }

                    let liAmount = li.get('amount') ?? 0,
                        liRevenue = li.get('revenue') ?? 0;
                    totalAmount += ((markup?.get('percent') ?? 0) / 10000) * liAmount;
                    totalRevenue += ((markup?.get('percent') ?? 0) / 10000) * liRevenue;
                });

                let isCR = this instanceof PJQ.models.changeRequests.ChangeRequestLineItem;
                result = isCR && !options.costs ? totalRevenue : totalAmount;
                this.set({
                    amount: !isCR ? totalAmount : 0,
                    revenue: totalRevenue,
                    unitPrice: totalAmount
                }, {silent: true});
            }
        } else if (this instanceof PJQ.models.changeRequests.ChangeRequestLineItem && !options.costs) {
            result = this.get('revenue') ?? 0;
        } else {
            result = this.get('amount') ?? 0;
        }
        let markupAmount = this.getMarkupAmount(financialMarkups, {
            horizontal: options.totalMarkups !== true,
            isAppliedLineItem: options.isAppliedLineItem
        });
        return result + markupAmount;
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function (financialMarkups, options = {}) {
        return this.getSubTotal(financialMarkups, options) + (this.get('taxAmount') ?? 0);
    }
});

PJQ.models.budget.LineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.get('budgetId')
            },
            {
                endpoint: 'lineitems',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.amount != null && model.budgetedCost == null) {
                model.budgetedCost = model.amount;
            }
        }
        return model;
    },
    erpSyncStatus: function () {
        let exObj = this.get('externalObject'),
            status = exObj != null && typeof exObj.status === 'number' ? exObj.status : 0;
        if (status !== PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
            return status;
        }

        return _.size(exObj.lastSync) === 0 || new Date(this.get('modifiedOn')) > new Date(exObj.lastSync) ? PJQ.constants.integrations.erp.syncStatuses.STALE : status;
    },
});

PJQ.models.budget.ForecastLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.options.budgetId
            },
            {
                endpoint: 'lineitems',
                value: this.get('lineItemId')
            },
            {
                endpoint: 'forecast'
            }
        ]);
    }
});

PJQ.models.budget.Budget = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'budgets'
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.budget.LineItems(model.lineItems, {
            budgetId: model.id
        });
        return model;
    },
    addLineItems: function (lineItems, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                },
                {
                    endpoint: 'lineitems'
                }
            ]),
            isAPIv2: true,
            data: lineItems
        }).post().done(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: 'Budget line items added'
            });
            this.lineItems.add(data, {merge: true});
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Failed to add budget line items'
            });
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    processImport: function (uploadId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id,
                },
                {
                    endpoint: 'budgets'
                },
                {
                    endpoint: 'lineitems'
                },
                {
                    endpoint: 'import',
                    value: uploadId
                }
            ]),
            isAPIv2: true
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    fetchForView: function (viewId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                },
                {
                    endpoint: 'views',
                    value: viewId
                }
            ]),
            isAPIv2: true
        }).get().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    updateLocked: function (isLocked, callback) {
        let startLocked = this.get('isLocked');
        if (startLocked !== isLocked) {
            this.set('isLocked', isLocked);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'budgets',
                        value: this.get('id')
                    }
                ]),
                isAPIv2: true,
                data: this.toJSON()
            }).patch().done(_.bind(_.bind(function (data) {
                PJQ.notifications.notify.successNotify({
                    message: 'Budget locked'
                });
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this))).fail(_.bind(function () {
                this.set('isLocked', startLocked);
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to lock budget'
                });
                if (typeof callback === 'function') {
                    callback(false);
                }
            }, this));
        }
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            default:
                return '';
        }
    },
});

PJQ.models.budget.BudgetModification = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.get('budgetId')
            },
            {
                endpoint: 'modifications'
            }
        ]);
    }
});

PJQ.models.budget.SubJob = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'subjobs',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'subjobs',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.CostCode = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.get('projectId') > 0 && !(this.id > 0)) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'costcodes',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'costcodes',
                value: this.id
            }
        ]);
    },
    getDisplayName: function () {
        let name = this.get('name');
        if (_.size(name) > 0) {
            return this.get('code') + ' - ' + name
        }
        return this.get('code');
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null, err);
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalId', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.budget.TaxCode = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'taxcodes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.CostType = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'costtypes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.UnitOfMeasure = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'unitsofmeasure',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.BillingPeriodSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'projectId',
    endpoint: function () {
        let params = []
        if (this.get('allowAutomate')) {
            params.push({
                parameter: 'allowAutomate',
                value: true
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'billingperiods'
            },
            {
                endpoint: 'settings'
            }
        ], params);
    },
    parse: function (model) {
        if (model) {
            this.billingPeriods = new PJQ.collections.budget.BillingPeriods(model.billingPeriods);
        }
        return model;
    },
    afterSave: function () {
        this.isFetched = false;
    }
});

PJQ.models.budget.BillingPeriod = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId') ? this.get('projectId') : this.options.projectId
            },
            {
                endpoint: 'billingperiods',
                value: this.id
            }
        ]);
    },
    // openPeriod: function (callback) {
    //     new PJQ.ajax.Request({
    //         endpoint: this.endpoint() + '/open',
    //         isAPIv2: true
    //     }).put().done(_.bind(function (res) {
    //         PJQ.notifications.notify.successNotify({
    //             message: 'Billing period opened'
    //         });
    //         if (typeof callback === 'function') {
    //             callback(res);
    //         }
    //     }, this)).fail(_.bind(function (xhr, err, result) {
    //         PJQ.notifications.notify.errorNotify({
    //             message: 'Failed to open billing period'
    //         });
    //     }, this));
    // },
    // closePeriod: function (callback) {
    //     new PJQ.ajax.Request({
    //         endpoint: this.endpoint() + '/close',
    //         isAPIv2: true
    //     }).put().done(_.bind(function (res) {
    //         PJQ.notifications.notify.successNotify({
    //             message: 'Billing period closed'
    //         });
    //         if (typeof callback === 'function') {
    //             callback(res);
    //         }
    //     }, this)).fail(_.bind(function (xhr, err, result) {
    //         PJQ.notifications.notify.errorNotify({
    //             message: 'Failed to close billing period'
    //         });
    //     }, this));
    // }
});

PJQ.models.budget.BudgetView = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings',
                value: 'budgets'
            },
            {
                endpoint: 'views',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.columns) {
            this.columns = new PJQ.collections.budget.ViewColumns(model.columns);
        }

        return model;
    },
    beforeSave: function () {
        _.each(this.columns.models, function (column) {
            if (column.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                let options = {
                    sources: column.calculations.toJSON()
                }
                column.set('options', options);
            }
        })
        this.set('columns', this.columns.toJSON());
    }
});

PJQ.models.budget.ViewColumn = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return;

        if (model.options) {
            if (model.options.sources && model.type === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                this.calculations = new PJQ.collections.budget.ViewColumnCalculations(model.options.sources);
            } else {
                this.calculations = new PJQ.collections.budget.ViewColumnCalculations();
            }
        }

        return model;
    }
});

PJQ.models.budget.ViewColumnCalculation = PJQ.models.BaseModel.extend();

// Collections
PJQ.collections.budget.TaxCodes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.TaxCode,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'taxcodes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'taxcodes'
                }
            ]);
        }
    }
});

PJQ.collections.budget.SubJobs = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.SubJob,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'subjobs'
            }
        ]);
    },
});

PJQ.collections.budget.CostTypes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.CostType,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'costtypes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'costtypes'
                }
            ]);
        }
    }
});

PJQ.collections.budget.CostCodes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.CostCode,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'costcodes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'costcodes'
                }
            ]);
        }
    },
    hasDivisions: function () {
        return null != _.find(this.models, function (costCode) {
            return _.size(costCode.get('division')) > 0;
        })
    },
    getForDivision: function (division) {
        let dSearch = (_.size(division) === 0 || division.toLowerCase() === 'no division') ? '' : division,
            empty = _.size(dSearch) === 0;
        return _.filter(this.models, (c) => {
            let div = c.get('division');
            return (empty && _.size(div) === 0) || div === dSearch;
        });
    },
    getDivisions: function () {
        return _.uniq(_.map(this.models, function (costCode) {
            return costCode.get('division') ?? '';
        }));
    },
    processImport: function (uploadId, projectId, callback) {
        let endpointArr = [];
        if (projectId > 0) {
            endpointArr.push({
                endpoint: 'projects',
                value: projectId
            });
        }

        endpointArr.push(...[
            {
                endpoint: 'costcodes'
            },
            {
                endpoint: 'import',
                value: uploadId
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr),
            isAPIv2: true
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    saveBulk: function (costCodes, subJobId, callback) {
        if (_.size(costCodes) > 0) {
            let params = [];
            if (subJobId > 0) {
                params.push({
                    parameter: 'subJobId',
                    value: subJobId
                })
            }

            let endpointArr = [];
            if (this.options.projectId > 0) {
                endpointArr.push({
                    endpoint: 'projects',
                    value: this.options.projectId
                });
            }

            endpointArr.push(...[
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'bulk'
                }
            ]);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, params),
                isAPIv2: true,
                data: {
                    costCodes: costCodes
                }
            }).post().done(_.bind(function (data) {
                this.add(data);
                if (typeof callback === 'function') {
                    callback(data);
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        }
    },
    pushERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (PJQ.helpers.objectHelpers.refinedType(res) === 'array') {
                _.each(res, function (cc) {
                    let model = this.get(cc.id);
                    if (model != null) {
                        model.set('externalObject', cc.externalObject, {silent: true});
                    }
                }, this)
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(false, err);
            }
        }, this));
    },
    deleteAll: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint(),
            isAPIv2: true
        }).delete().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(false, err);
            }
        }, this));
    }
});

PJQ.collections.budget.UnitsOfMeasure = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.UnitOfMeasure,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'unitsofmeasure'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'unitsofmeasure'
                }
            ]);
        }
    }
});

PJQ.collections.budget.BillingPeriods = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.BillingPeriod
});

PJQ.collections.budget.LineItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.LineItem
});

PJQ.collections.budget.BudgetModifications = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.BudgetModification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.options.budgetId
            },
            {
                endpoint: 'modifications'
            }
        ]);
    }
});

PJQ.collections.budget.ViewColumns = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ViewColumn
});

PJQ.collections.budget.ViewColumnCalculations = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ViewColumnCalculation
});

PJQ.collections.budget.ForecastLineItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ForecastLineItem
});

PJQ.collections.budget.BudgetViews = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.BudgetView,
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings',
                value: 'budgets'
            },
            {
                endpoint: 'views'
            }
        ]);
    }
});

PJQ.collections.budget.Snapshots = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'budgets'
            },
            {
                endpoint: 'snapshots'
            }
        ]);
    }
});
